import { createGlobalStyle } from 'styled-components';
import ReviewLocation from '../images/orange-location-box.svg'
const GlobalStyles = createGlobalStyle`
h1,h2,h3,h4,h5,h6 {margin-bottom: 0px;}
  .header-container{
    max-width: 1390px !important; 
    padding: 0 15px !important;

    @media only screen and (min-width: 1200px) and (max-width: 1440px){
      padding: 0 40px !important;
    }
      button.serc.btn.btn-outline-success {
    display: none;
}
    .navbar-nav{
      a.nav-link {
          color: #fff;
          padding-left:0;
          padding-right:0;

          @media screen and (max-width: 1200px){
            font-size: 14px;
            line-height: 20px;
          }
      }
    }
  }
  .cont-w{
    max-width: 1230px !important;
    padding: 0 15px !important;
  }
  .form-control{
    &:focus{
      box-shadow: none;
    }
  }

.donate-now-btn{
  background: #F7931E !important;
  border: none !important;
  border-radius: 10px !important;
  box-shadow: 3px 5px 20px #00000033 !important;
  font-family: "Jost", sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 26px !important;
  padding: 11px 33px !important;
  color: #333333 !important;

  &:hover{
      background: #FFD495 !important;
      color: #333333 !important;
  }
}


  .dropdown-menu, .custom-scrollbar{
    border: none;

    &::-webkit-scrollbar-track
      {
        border-radius: 20px;
        overflow: hidden;
      }

      &::-webkit-scrollbar
      {
          width: 8px;
          height: 10px
          overflow: hidden;
      }

      &::-webkit-scrollbar-thumb
      {
          border-radius: 20px;
          background-color: #E1E1E1;
          box-shadow: 0px 10px 30px #00000033;
          overflow: hidden;
      }
  }


  .write-yellow-btn{
    background: #F9DC70 !important;
    box-shadow: 3px 5px 20px #00000033  !important;
    border-radius: 10px  !important;
    border-color: #F9DC70  !important;
    font-family: "Jost", sans-serif  !important;
    font-size: 16px  !important;
    line-height: 24px  !important;
    font-weight: 500  !important;
    font-style: normal  !important;
    color: #333333  !important;
    padding: 10px 12px  !important;
    transition: all 0.5s  !important;
    &:active{
      background-color: #FFD495 !important;
      border-color: #FFD495 !important;
      color: #333333 !important;
      transition: all 0.5s !important;
    }
    &:focus-visible {
      background-color: #FFD495 !important;
      border-color: #FFD495 !important;
      color: #333333 !important;
      transition: all 0.5s !important;
      box-shadow: none;
    }
   &:hover{
        background-color: #FFD495 !important;
        border-color: #FFD495!important;
        color: #333333!important;
        transition: all 0.5s!important;
    }
}
//   .write-yellow-btn{
//     background: #F9DC70;
//     box-shadow: 3px 5px 20px #00000033;
//     border-radius: 10px;
//     border-color: #F9DC70;
//     font-family: "Jost", sans-serif;
//     font-size: 16px;
//     line-height: 24px;
//     font-weight: 500;
//     font-style: normal;
//     color: #333333;
//     padding: 7px 23px;
//     transition: all 0.5s;

//     &:hover{
//         background-color: #FFD495;
//         border-color: #FFD495;
//         color: #333333;
//         transition: all 0.5s;
//     }
// }
.donate-now-btn{
  background: #F7931E !important;
  border: none !important;
  border-radius: 10px !important;
  box-shadow: 3px 5px 20px #00000033 !important;
  font-family: "Jost", sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  line-height: 26px !important;
  padding: 11px 33px !important;
  color: #333333 !important;

  &:hover,&:active{
      background: #FFD495 !important;
      color: #333333 !important;
  }
  &:focus-visible{
    box-shadow:none !important;
  }

}
.btn-outline-success-blue{
  background: #01606F !important;
  border: none !important;
  color: #fff !important;
  font-family: "Jost", sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  padding: 12px 20px !important;
  transition: all 0.5s !important;
  border-radius: 10px !important;
  box-shadow: 3px 5px 20px #00000033 !important;
  &:hover,&:active{
    background: #FFD495 !important;
    color: #333333 !important;
    transition: all 0.5s;
  }
  &:focus-visible{
    box-shadow:none !important;
  } 
}
.learn-qualify-btn {
  background: #FFD495;
  font-size: 16px;
  font-family: 'Jost', sans-serif;
  font-weight: 500;
  line-height: 22px;
  color: #333333;
  padding: 13px 20px;
  border-radius: 10px;
  border: none;
  box-shadow: 3px 5px 20px #00000033;
  &:hover{
      background: #016B7B;
      color: #fff;
  }
  &:active{
    background: #016B7B !important;
    color: #fff;
}
}
 .claim-nonprofit-modal{
     
  .modal-dialog{
      max-width: 400px;
      margin: 0 auto;
       @media screen and (max-width:360px){
           max-width: 293px;
      
       }
  }
  .modal-body{
    padding:0 20px 20px 20px;
      img{
        width:100%;
      }
    }
    .modal-header{
      border:none;
      padding: 20px 20px 0 0px;
      }
      .btn-close {
        box-sizing: border-box;
        position: relative;
        display: block;
        background:#000;
        width: 21px;
        height: 20px;
        border: 2px solid transparent;
        border-radius: 40px;
        cursor: pointer;
        opacity: 100;
        z-index: 2;
        
        &:focus{
          box-shadow:none;
        }
    }
    .btn-close::after,
    .btn-close::before {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 13px;
        height: 2px;
        background: #fff;
        transform: rotate(45deg);
        border-radius: 5px;
        top: 7px;
        left: 2px;
    }
    .btn-close::after {
        transform: rotate(-45deg)
    }
    .modal-btn{
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 3px 5px 20px #00000033;
      border: 2px solid #01606F;
      border-radius: 10px;
      color: #01606F;
      font-size: 16px;
      line-height: 23px;
      padding:11px 3px;
      font-family: "Jost", sans-serif;
      font-weight: 500;
        width: 100%;
      &.fill-btn {
        background: #01606F;
        color: #fff;
      }
      &:hover{
        background:#FFD495;
        border: 2px solid #FFD495;
        color:#333333;
      }
    }

  }
    .donateModal{
    .modal-body{
        padding: 0px 34px 20px;

        @media screen and (max-width: 575px){
          padding: 0px 15px 15px;
        }

          img{
            width:auto;
            margin: 0 auto;
            display: block;
          }
        }
        .donate-now-btn {
          background: #F7931E !important;
          border: 1px solid #F7931E !important;
          color: #333333 !important;
        &:hover{
          background:#FFD495 !important;
          border: 1px solid #FFD495 !important;
        } 
      }
    .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible{
      box-shadow: none;
    }
    input:-webkit-autofill {
      background-color: transparent !important; 
    }
    button:focus:not(:focus-visible) {
      outline: 0;
      box-shadow: none;
    }


    .ant-tooltip .ant-tooltip-inner {
        background-color: transparent !important;
        font-family: "Jost", sans-serif  !important;
        font-size: 18px  !important;
        font-weight: 600  !important;
        line-height: 27px  !important;
        margin-bottom: 0  !important;
        color: #000 !important;
        box-shadow: none !important;
    }

    .ant-tooltip-arrow {
      display: none !important;
    }

    .ant-tooltip-inner{
      &::before {
        width: 25px !important;
        height: 33px !important;  
        background-image:url(${ReviewLocation});
        background-position: left;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
    .pagination-block{
      background: #F1FEFF;
      padding: 3px 0;
    }
`;
export default GlobalStyles;